import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { TrainingProgramAdd } from '#app/routes/mocra+/_form+/components/training-programs/add.tsx'
import { TrainingProgramCard } from '#app/routes/mocra+/_form+/components/training-programs/card.tsx'
import { type TrainingProgramDraft } from '#app/routes/mocra+/_form+/components/training-programs/types.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type TrainingProgramListItem = {
	readonly draft: TrainingProgramDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly programs: ReadonlyArray<TrainingProgramListItem>
	readonly onAdd: (draft: TrainingProgramDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function TrainingProgramsSection({
	resources,
	programs,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Training programs"
			description="List the core compliance and GMP trainings, how they are delivered, and how completion is tracked."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{programs.length > 0 ? (
					programs.map((program, index) => {
						const errors = program.errors
						return (
							<TrainingProgramCard
								key={`training-program-${index}`}
								program={program.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add a training program to document how you deliver compliance labs
						and who attends.
					</p>
				)}
			</div>
			<TrainingProgramAdd onSubmit={onAdd} />
		</Section>
	)
}
